import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

import ArrowRight from "./arrowRight"
import facebookImage from "../images/fontawesome/facebook-f-brands.svg"
import instagramImage from "../images/fontawesome/instagram-brands.svg"
import youtubeImage from "../images/fontawesome/youtube-brands.svg"

const ExternalLink = ({ heading, link, children }) => (
  <a href={link} className="external-footer-link">
    <span className="external-footer-link__heading">
      {heading} <ArrowRight />
    </span>{" "}
    {children}
  </a>
)

const SocialMediaLink = ({ link, image, alt, title }) => (
  <a href={link} className="social-media-link" target="_blank" rel="noreferrer">
    <img
      src={image}
      alt={alt}
      title={title}
      className="social-media-icon"
      width="35px"
      height="35px"
    />
  </a>
)

const Footer = () => {
  const { name, address, zipCode, city, facebook, instagram, youtube } =
    useStaticQuery(graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            name
            address
            zipCode
            city
            facebook
            instagram
            youtube
          }
        }
      }
    `).site.siteMetadata

  return (
    <footer className="footer">
      <div className="fullwidth__child-wrapper">
        <div className="footer__top">
          <div>
            <h2 className="footer__heading">
              <Link to="/kontakt" className="link footer__link">
                Kontakt <ArrowRight />
              </Link>
            </h2>
            <p>
              {name}
              <br />
              {address}
              <br />
              {`${zipCode} ${city}`}
            </p>
          </div>
          <div>
            <h2 className="footer__heading">Sociala medier</h2>
            <ul className="list social-media-links">
              <li>
                <SocialMediaLink
                  alt="Instagram equmeniakyrkan_orbyhus"
                  title="equmeniakyrkan_orbyhus"
                  link={instagram}
                  image={instagramImage}
                />
              </li>
              <li>
                <SocialMediaLink
                  alt="Facebook @bjorkbackskyrkan"
                  title="equmeniakyrkan_orbyhus"
                  link={facebook}
                  image={facebookImage}
                />
              </li>
              <li>
                <SocialMediaLink
                  alt="Youtube"
                  title="Youtube"
                  link={youtube}
                  image={youtubeImage}
                />
              </li>
            </ul>
          </div>
          <ExternalLink
            heading="Region Mitt"
            link="https://equmeniakyrkan.se/mitt/"
          >
            <p>Regionalt samarbete med andra Equmeniakyrkor</p>
          </ExternalLink>

          <ExternalLink
            heading="Equmeniakyrkan"
            link="https://equmeniakyrkan.se/"
          >
            <p>Vårt samfund</p>
          </ExternalLink>
        </div>
        <div className="footer__bottom">
          <div className="created-by">
            Skapad med ❤️ av{" "}
            <a
              className="link link--contrast"
              href="https://accodeing.com/hosting"
            >
              Din Webbstudio i Gyllby
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
